import Header from "../../../molecules/layouts/navbar/Header";

const MobileLayout = ({ children }) => {
  return (
    <div className="w-full flex min-h-screen">
      <div className="flex-1 flex flex-col bg-gray-100 overflow-y-auto">
        <Header />
        {children}
      </div>
    </div>
  );
};

export default MobileLayout;
